import script from "./ResidentContactCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ResidentContactCard.vue?vue&type=script&setup=true&lang=js"

import "./ResidentContactCard.vue?vue&type=style&index=0&id=db2c6334&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-db2c6334"]])

export default __exports__